export default "__VITE_ASSET__usynBi2u__"